"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SectionedContent = _interopRequireDefault(require("./SectionedContent"));
var _GenericList = _interopRequireDefault(require("./../lists/GenericList"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function ShowAboutContent(_ref) {
  var _series$public_conten;
  let {
    series,
    castStr,
    showUpcoming,
    type,
    nextAirDates
  } = _ref;
  const renderUpcomingContent = () => {
    return nextAirDates.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "upcoming-airings"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "h5"
    }, "Upcoming Airings"), /*#__PURE__*/_react.default.createElement(_GenericList.default, {
      list: nextAirDates,
      classname: 'upcoming-airings__list'
    })) : /*#__PURE__*/_react.default.createElement("div", {
      className: "upcoming-airings"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "h5"
    }, "Upcoming Airings"), /*#__PURE__*/_react.default.createElement("p", null, type === 'series' ? (0, _htmlReactParser.default)("This show doesn't have any episodes scheduled in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href=\"/schedule\" className=\"inline-anchor\">full schedule</a> to see what shows are airing.") : (0, _htmlReactParser.default)("This movie doesn't have any airings in the next two weeks. Please check back to see when it will be airing again.<br></br>Or you can view our <a href=\"/schedule\" className=\"inline-anchor\">full schedule</a> to see what shows are airing.")));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SectionedContent.default, {
    sections: [{
      header: {
        type: 'primary',
        title: "About ".concat(series.title)
      },
      content: series.series_synopsis
    }, {
      header: {
        type: 'secondary',
        title: 'Starring'
      },
      content: castStr === '' ? '' : "<p>".concat(castStr, "</p>")
    }, {
      header: {
        type: 'secondary',
        title: 'Director'
      },
      content: series !== null && series !== void 0 && series.director ? "<p>".concat(series === null || series === void 0 ? void 0 : series.director, "</p>") : ''
    }, {
      header: {
        type: 'secondary',
        title: 'Creators'
      },
      content: series !== null && series !== void 0 && series.creators ? "<p>".concat(series === null || series === void 0 ? void 0 : series.creators, "</p>") : ''
    }, {
      header: {
        type: 'secondary',
        title: 'Public & Critical Acclaim'
      },
      content: (_series$public_conten = series === null || series === void 0 ? void 0 : series.public_content) !== null && _series$public_conten !== void 0 ? _series$public_conten : ''
    }]
  }), showUpcoming && renderUpcomingContent());
}
var _default = exports.default = ShowAboutContent;